module.exports = __webpack_public_path__ + "img/1553340487.a4967ce5.jpg";